// extracted by mini-css-extract-plugin
export var hero = "hero-module--hero--25w3J";
export var image = "hero-module--image--3EwX_";
export var details = "hero-module--details--2GmK8";
export var title = "hero-module--title--1vq51";
export var content = "hero-module--content--vT9Ih";
export var discount = "hero-module--discount--20Cr_";
export var blinkAnimation = "hero-module--blink-animation--2KTGN";